<div class="container__main container__main--full" *ngIf="journey">
    <msc-timeline [context]="'traject'" [contextId]="journey.id"></msc-timeline>
</div>
